// axios
import axios from 'axios'

let baseURL = ''
let baseURLnoAPI = ''

if (process.env.NODE_ENV === 'development') {
  baseURL = 'http://coyag-backend.test/api/'
  baseURLnoAPI = 'http://coyag-backend.test/'
} else if (process.env.NODE_ENV === 'production') {
  baseURL = 'https://videoportaldenegocios.online/api/'
  baseURLnoAPI = 'https://videoportaldenegocios.online/'
}

export default axios.create({
  baseURL,
  baseURLnoAPI
  // You can add your headers here
})
